import React from "react";

interface PrintableProps {
  children: React.ReactNode;
  style: React.CSSProperties;
}

// eslint-disable-next-line react/display-name
export const Printable = React.forwardRef<HTMLDivElement, PrintableProps>(({ children, style }, ref) => {
  return (
    <div style={style} ref={ref}>
      {children}
    </div>
  );
});
